/* eslint-disable no-unused-vars, no-restricted-syntax */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons';
// import { SubHeading } from '../../../components';
import './IntroHeader.css';

const IntroHeader = () => (
  <div id="intro">
    <div className="app__headerIntro app__wrapper section__padding">

      {/* BRAND TEXT DISPLAY */}
      <div className="introBrandContainer">
        <h1 className="introBrandText">CurvSort</h1>
      </div>

      {/* PLATFORM POSITIONING */}
      <div className="app__wrapper_info_Intro">
        <h1 className="headtext__cormorant" style={{ fontSize: '48px', lineHeight: '1.3', textAlign: 'center' }}>
          Enterprise AI Infrastructure &amp; Intelligent Workflow Systems
        </h1>

        <p className="p__opensans" style={{ margin: '2rem 0', lineHeight: '1.8' }}>
          CurvSort builds enterprise AI platforms spanning runtime infrastructure,
          operational observability, and intelligent workflow systems. Our products help
          organizations monitor complex AI agent environments, improve execution reliability,
          and deploy AI-powered applications with stronger visibility, governance, and cost control.
        </p>

        {/* CORE CORE SYNERGY MATRIX */}
        <div className="intro-matrix">
          <div className="matrix-column">
            <h4>Infrastructure & Runtime Intelligence</h4>
            <p>• LexiLensAI (AI Agent Observability & Runtime Guardrails)</p>
          </div>
          <div className="matrix-column">
            <h4>Applied AI Workflow Systems</h4>
            <p>• LexemeAI (Multimodal Instructional Intelligence & Educator Workflow Platform)</p>
          </div>
        </div>

        <FontAwesomeIcon className="angleDownLogo" icon={faAngleDoubleDown} />
      </div>

    </div>
  </div>
);

export default IntroHeader;
